'use client';

import Skeleton from '@carvana/ds-skeleton';
import { usePricingUpdate } from '~/context/flp-rsc/PricingUpdateContext';
import { BodyType, Inventory, Price } from './VehicleCard.styles';

type OwnProps = {
  count?: number;
  displayName: string;
  minMonthlyPayment?: number;
};

export default function VehicleCardStats({
  count,
  displayName,
  minMonthlyPayment
}: OwnProps) {
  const { isPending } = usePricingUpdate();

  if (isPending) {
    return (
      <>
        <div>
          <BodyType>{displayName} starting at</BodyType>
          <Skeleton width={80} height={28} className="rounded-md mt-4" />
        </div>
        <div>
          <Skeleton width={110} height={20} className="rounded-md" />
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <BodyType>
          {minMonthlyPayment === undefined ? (
            displayName
          ) : (
            <>
              {displayName} starting at <br />
              <Price>${minMonthlyPayment}/mo</Price>
            </>
          )}
        </BodyType>
      </div>
      {count !== undefined && (
        <div>
          <Inventory>{count.toLocaleString('en-US')} Available</Inventory>
        </div>
      )}
    </>
  );
}
